import icon from '../../includedAssets/sprite.loading.png';
import $ from 'jquery';

class Loading {
  constructor() {
  }

  add() {
    const imageElement = $('<img>', { class: 'icon' }).attr('src', icon);
    imageElement.appendTo($('#loading-container'));
    this.hide();
    return this;
  }

  show() {
    $('#loading-container').show();
  }

  hide() {
    $('#loading-container').hide();
  }

}

export default new Loading();